const Loader = ({ className, helperText = 'LOADING' }) => (
  <div id="loader-infinite" className={className}>
    <img src="/images/loading.gif" alt="" />
    {helperText}
  </div>
);

export default Loader;
